import { createSelector } from 'reselect';
import { ApplicationState } from '../store';

export const getBillingStore = (state: ApplicationState) => state.billing;

export const showCreditCardModal = createSelector(
  getBillingStore,
  (billingStore) => billingStore.showCreditCardModal,
);

export const getIsLoadingPaymentMethods = createSelector(
  getBillingStore,
  (billingStore) => billingStore.isLoadingPaymentMethods,
);

export const getPaymentMethods = createSelector(
  getBillingStore,
  (billingStore) => billingStore.paymentMethods,
);

export const getBillingFrequency = createSelector(
  getBillingStore,
  (billingStore): number | undefined => billingStore.paymentMethods.billingFrequency,
);

export const getPaymentThreshold = createSelector(
  getBillingStore,
  (billingStore): number | undefined => billingStore.paymentMethods.paymentThreshold,
);

export const showChangePaymentModal = createSelector(
  getBillingStore,
  (billingStore) => billingStore.showChangePaymentModal,
);

export const getNewPaymentType = createSelector(
  getBillingStore,
  (billingStore) => billingStore.newPaymentType,
);

export const showCCUpdatedNotification = createSelector(
  getBillingStore,
  (billingStore) => billingStore.ccUpdatedNotification,
);

export const showChangePaymentNotificationSuccess = createSelector(
  getBillingStore,
  (billingStore) => billingStore.changePaymentNotificationSuccess,
);

export const showChangePaymentNotificationError = createSelector(
  getBillingStore,
  (billingStore) => billingStore.changePaymentNotificationError,
);

export const getPaymentProcessingError = createSelector(
  getBillingStore,
  (billingStore) => billingStore.paymentProcessingError,
);
